import React from 'react';
import Header from '../components/Header/Header';
import HeroSlider from '../components/HeroSlider/HeroSlider';
import CompanyIntro from '../components/CompanyIntro/CompanyIntro';
import Services from '../components/Services/Services';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import RecentProjects from '../components/RecentProjects/RecentProjects';
import Testimonials from '../components/Testimonials/Testimonials';
import OurClients from '../components/OurClients/OurClients';
import CallToAction from '../components/CallToAction/CallToAction';
import Footer from '../components/Footer/Footer';

function HomePage() {
  return (
    <>
      <Header />
      <HeroSlider />
      <CompanyIntro />
      <Services />
      <WhyChooseUs />
      <RecentProjects />
      <Testimonials />
      <OurClients />
      <CallToAction />
      <Footer />
    </>
  );
}

export default HomePage;